import { Service } from '../service.js'
import { env } from '../env.js'

class LegalizeTotalizadorService extends Service {
    constructor(controleDeInstancia) {
        super(controleDeInstancia);
    
        this.url = env.url + "legalize/totalizador";
        
        this.controladoresDeInstancia = {
          countForCards: new AbortController(),
        }
    }

    async countForCards(queryObject) {
        let queryString = '';
        if (queryObject) {
            queryString = this.converterObjetoDeFiltrosParaURIEncodedString(queryObject)
        }
        let url = `${this.url}${queryString}`;
        return await this.get(url, this.controladoresDeInstancia.countForCards);
    }
}

export const legalizeTotalizadorService = new LegalizeTotalizadorService();